// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"5a848ecc57e781affe58","655":"6fe2a4c6386afd322a6a"}[chunkId] + ".js";
};